import React from 'react';
import { managementSubnavStyles as styles } from '../../common/managementSubnavStyles';

export type CommunicationTab = 'support' | 'chats' | 'feedback';

const tabs: { key: CommunicationTab; label: string }[] = [
    { key: 'support', label: 'Support Queue' },
    { key: 'chats', label: 'Chats' },
    { key: 'feedback', label: 'Feedback' },
];

const CommunicationTabs: React.FC<{ activeTab: CommunicationTab; onChange: (tab: CommunicationTab) => void }> = ({ activeTab, onChange }) => (
    <nav aria-label="Communication" className={styles.tabs}>
        {tabs.map(tab => <button key={tab.key} type="button" aria-current={activeTab === tab.key ? 'page' : undefined} onClick={() => onChange(tab.key)} className={`${styles.tab} ${activeTab === tab.key ? styles.activeTab : styles.inactiveTab}`}>{tab.label}</button>)}
    </nav>
);

export default CommunicationTabs;
